import { EvaluatePremiumRequest, FormikInsurance } from "src/types";
import { deleteEmptyKeys } from "src/utils";

export const toEvaluatePremiumRequest = (
  values: FormikInsurance
): EvaluatePremiumRequest | undefined => {
  const insuredNumber = Number(values.insuredNumber);

  if (insuredNumber === 0 || !insuredNumber) {
    return undefined;
  }

  return deleteEmptyKeys({
    giorni: Number(values.insuredDaysNumber),
    assicurati: Number(values.insuredNumber),
    codProdotto: Number(values.coverageTypeRadios),
    frazionamento: Number(values.insuredPeriodType),
  });
};
